import { render, staticRenderFns } from "./usersDialog.vue?vue&type=template&id=88fb8410&scoped=true"
import script from "./usersDialog.vue?vue&type=script&lang=js"
export * from "./usersDialog.vue?vue&type=script&lang=js"
import style0 from "./usersDialog.vue?vue&type=style&index=0&id=88fb8410&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88fb8410",
  null
  
)

export default component.exports